<template>
  <div class="container-fluid main-content">
    <div class="row text-left">
    <div class="col-sm-6">
      <div v-if="detentions && Object.entries(detentions).length > 0" class="mb-5">
        <h5>Student Info</h5>
        <div>Name: {{ detentions.student.name }}</div>
        <div>Grade: {{ detentions.student.grade }}</div>
      </div>

      <h5>Detention history</h5>
      <div v-if="detentions && detentions.hasOwnProperty('detentionRecord') && canSee">
        <div v-for="(record,index) in detentions.detentionRecord" v-bind:key="index" class="card bg-light mb-3" >
          <div v-if="record.constructor === Object">
            <div class="card-header">{{ record.date.toDate().toDateString() }}</div>
            <div class="card-body">
              <ul class="list-unstyled">
              <li v-for="(reason,index) in record.reasons" v-bind:key="index">{{ reason }}</li>
              </ul>
            </div>
          </div>
          <div v-else>
            <div class="card-header">{{ record.toDate().toDateString() }}</div>
            <div class="card-body">
              <p class="card-text">No reasons were recorded.</p>
            </div>
          </div>
        </div>
      </div>
      <p v-else class="font-italic">This student hasn't served any detentions</p>
    </div>
    <div class="col-sm-6 text-center">
      <h5>Infraction history</h5>
      <div v-if="detentions && detentions.hasOwnProperty('infractionRecord') && canSee">
        <ul class="list-group">
          <li v-for="(infraction,index) in detentions.infractionRecord" v-bind:key="index" class="list-group-item">
            {{ infraction }}
          </li>
        </ul>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { db } from '@/main.js'

export default {
    name: "StudentHistory",
    data () {
      return {
        detentions: {}
      }
    },
    computed: {
      canSee: function() {return this.detentions.student.org == this.$root.sharedState.org}
    },
    firestore () {
      return {
          detentions: db.collection('detentions').doc(this.$route.params.id)
      }
    },
}
</script>
